import { render, staticRenderFns } from "./yinsiPolicy.vue?vue&type=template&id=00de34fb&scoped=true"
import script from "./yinsiPolicy.vue?vue&type=script&lang=js"
export * from "./yinsiPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00de34fb",
  null
  
)

export default component.exports